import { render, staticRenderFns } from "./investigationPlanPop.vue?vue&type=template&id=5b235781"
import script from "./investigationPlanPop.vue?vue&type=script&lang=js"
export * from "./investigationPlanPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b235781')) {
      api.createRecord('5b235781', component.options)
    } else {
      api.reload('5b235781', component.options)
    }
    module.hot.accept("./investigationPlanPop.vue?vue&type=template&id=5b235781", function () {
      api.rerender('5b235781', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/hea/investigationPlanPop.vue"
export default component.exports